export const NEW_GAME = 'NEW_GAME';
export const ONE_MOVE = 'ONE_MOVE';
export const MOVE_BACK = 'MOVE_BACK';

export const ACTION_NEW_GAME = () => ({
  type: NEW_GAME,
});
export const ACTION_ONE_MOVE = payload => ({
  type: ONE_MOVE,
  payload,
});
export const ACTION_MOVE_BACK = () => ({
  type: MOVE_BACK,
});
